import React from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../api';
import { Text, Heading, Box } from '@chakra-ui/react';
// import { Link } from 'react-router-dom';
import Login from '../components/Login';
import Logout from '../components/Logout';
import Footer from '../components/Footer';
import Dashboard from './Dashboard';
import Promoter from './Promoter';
import Cashier from './Cashier';

function Operator() {
  const [user] = useAuthState(auth);

  if (!user) return <Login />;

  if (user.displayName === 'admin') {
    return <Dashboard />;
  }

  if (user.displayName === 'promoter') {
    return <Promoter />;
  }

  if (user.displayName === 'cashier') {
    return <Cashier />;
  }
  
  return (
    <>
      <Heading mt={5} mb={0} color={'white'}>
        Dashboard operatore
      </Heading>
      <Text mb={3}>{process.env.REACT_APP_PROJECT_ID}</Text>
      <Box w='100%' border={'3px solid teal'} borderRadius={15} p={5} mb={10} color='white'>
        <Text fontSize={'lg'} mb={5}>
          Sei autenticato come <b>{user.email}</b>. <br />
          <br />
          In qualità di operatore potrai smarcare gli ordini dei clienti, sarà sufficiente
          inquadrare i QR code degli ordini con la telecamera del tuo smartphone.
        </Text>
        <Text fontSize={'lg'} mb={5}>
          Puoi chiudere questa pagina o lasciarla aperta nel tuo browser.<br/><br/>
          Se vuoi disconnetterti come operatore clicca sul pulsante di Logout.
        </Text>
      </Box>
      <Logout />
      <Footer />
    </>
  );
}
export default Operator;
